import { EventEmitter } from "eventemitter3";

class JsSdkEventEmit {
  remoteHttpEmitter: EventEmitter;
  constructor() {
    this.remoteHttpEmitter = new EventEmitter();
  }

  addEventListener = <T = unknown>(
    eventName: string,
    callBack: (event: T) => void,
  ): { (): void } => {
    this.remoteHttpEmitter.addListener(eventName, callBack);
    return () => {
      this.remoteHttpEmitter.removeListener(eventName, callBack);
    };
  };

  emitEvent = <T = unknown>(eventName: string, eventData: T) => {
    this.remoteHttpEmitter.emit(eventName, eventData);
  };

  removeAllListener = () => {
    this.remoteHttpEmitter.removeAllListeners();
  };
}

export { JsSdkEventEmit };

export const JsSdkEventEmitInstance = new JsSdkEventEmit();
